import { http } from 'lib/services/http';
import { getErrorMessage } from 'utils/api-normalizers';
import { cancelableAction } from 'utils/redux-axios-helpers';

import { prepareSearchParams } from './helpers';
import {
  ROLES_REQUEST,
  ROLES_SUCCESS,
  ROLES_FAILURE,
  ROLE_REQUEST,
  ROLE_SUCCESS,
  ROLE_FAILURE,
  ROLE_SAVE_REQUEST,
  ROLE_SAVE_SUCCESS,
  ROLE_SAVE_FAILURE,
  ROLE_UPDATE_REQUEST,
  ROLE_UPDATE_SUCCESS,
  ROLE_UPDATE_FAILURE,
  ROLE_DELETE_REQUEST,
  ROLE_DELETE_SUCCESS,
  ROLE_DELETE_FAILURE,
} from './types';

const ROLES_API_PATH = '/platform-admin/v1/roles';

export const getRoles = (rawParams = {}, setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: ROLES_REQUEST });
    const params = prepareSearchParams(rawParams);
    return http
      .get(`${ROLES_API_PATH}/search`, { params })
      .then((payload) => {
        const roles = { ...payload };
        // Remove the Global Account Manager from the list of
        // roles on the Advanced Roles and Permissions page.
        const filteredRoles = roles.result.filter(
          (role) => role.role_type !== 'SUPER_ADMIN',
        );

        roles.result_count -= 1;

        roles.result = [...filteredRoles];
        dispatch({ type: ROLES_SUCCESS, payload: roles });
      })
      .catch((error) => {
        setSnackbar({
          message: getErrorMessage(error, 'Could not load roles!'),
          severity: 'error',
        });
        dispatch({ type: ROLES_FAILURE, payload: error });
      });
  };
};

export const getRole = (id) => {
  return cancelableAction(
    getRole,
    ({ cancelToken, cancelable, isCanceled }, dispatch) => {
      dispatch({ type: ROLE_REQUEST });

      return cancelable(
        http
          .get(`${ROLES_API_PATH}/retrieve?name=${id}`, { cancelToken })
          .then((payload) => dispatch({ type: ROLE_SUCCESS, payload }))
          .catch((error) => {
            if (isCanceled(error)) return;

            dispatch({ type: ROLE_FAILURE, payload: error });
          }),
      );
    },
  );
};

export const saveRole = (payload, setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: ROLE_SAVE_REQUEST });
    return http
      .post(`${ROLES_API_PATH}`, payload)
      .then((payload) => {
        dispatch({ type: ROLE_SAVE_SUCCESS, payload });
        setSnackbar({
          message: 'Role successfully created!',
          severity: 'success',
        });
      })
      .catch((error) => {
        setSnackbar({
          message: getErrorMessage(
            error,
            'Role could not be created, data is invalid!',
          ),
          severity: 'error',
        });
        dispatch({ type: ROLE_SAVE_FAILURE, payload: error });
      });
  };
};

export const updateRole = ({ name }, payload, setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: ROLE_UPDATE_REQUEST });
    return http
      .put(`${ROLES_API_PATH}/${name}`, payload)
      .then((payload) => {
        dispatch({ type: ROLE_UPDATE_SUCCESS, payload });
        setSnackbar({
          message: 'Role successfully created!',
          severity: 'success',
        });
      })
      .catch((error) => {
        setSnackbar({
          message: getErrorMessage(
            error,
            'Role could not be updated, data is invalid!',
          ),
          severity: 'error',
        });
        dispatch({ type: ROLE_UPDATE_FAILURE, payload: error });
      });
  };
};

export const deleteRole = (role, setSnackbar, setOpenModal) => {
  return (dispatch) => {
    dispatch({ type: ROLE_DELETE_REQUEST });

    return http
      .delete(`${ROLES_API_PATH}/${role.name}/delete`)
      .then(() => {
        dispatch({ type: ROLE_DELETE_SUCCESS, payload: role });
        setOpenModal(false);
        setSnackbar({
          message: 'Role successfully deleted!',
          severity: 'success',
        });
      })
      .catch((error) => {
        setSnackbar({
          message: getErrorMessage(
            error,
            'Role could not be deleted for some reason!',
          ),
          severity: 'error',
        });
        dispatch({ type: ROLE_DELETE_FAILURE, payload: error });
      });
  };
};

export const cleanRole = () => {
  return { type: ROLE_SUCCESS, payload: null };
};
